import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var updateVersionRes;

export const updateVersionTodo = createAsyncThunk('updateVersion', async (data) => {
    // console.log(data);
    try {
        // Wait for both API calls to complete
        const resAndroid = await verionsUpdate(data?.andriod_version, "android", data?.andriod_id);
        const resIos = await verionsUpdate(data?.ios_version, "ios", data?.ios_id);

        // Combine both responses if needed
        updateVersionRes = {
            android: resAndroid.data,
            ios: resIos.data
        };

        return updateVersionRes;

    } catch (error) {
        updateVersionRes = error?.response?.data || { message: "Something went wrong" };
        return updateVersionRes;
    }
});

const verionsUpdate = async (updateversion, type, id) => {
    return await axios({
        method: "put",
        url: `${process.env.REACT_APP_API_URL}version/${id}`,
        data: {
            type: type,
            version: updateversion
        },
        headers: {
            "Content-Type": "application/json",
            "Authorization": 'Bearer ' + localStorage.getItem('token')
        }
    });
};
